export const API_URL = process.env.REACT_APP_API_URL;

export function getSupportUrl(status) {
    return API_URL + '/supports?status=' + status;
}

export function createSupportUrl() {
    return API_URL + '/supports';
}
